<section class="service-intro content-wrapper">
  <div class="service-content">
    <h1 class="title">Video Production & Corporate Photography in Goa</h1>
    <p class="description">
      Geekeno delivers expert video production and photography services in Goa,
      helping brands across India and globally tell compelling stories through
      cinematic visuals. From concept development, filming, and editing to
      remote post-production, we create promotional videos, social media
      content, and brand photography that inspire action and elevate your
      identity.
    </p>
  </div>
  <div class="decorative-elements is-hidden-touch">
    <img
      src="/assets/services/deco-element.png"
      loading="eager"
      fetchpriority="high"
      width="265"
      height="400"
      alt=""
      role="presentation"
    />
  </div>
</section>

<section class="services">
  <div class="service-divider"></div>
  <div class="service-row content-wrapper">
    <div class="service-image">
      <img
        src="/assets/services/video-production/photography.webp"
        loading="eager"
        fetchpriority="high"
        width="445"
        height="431"
        alt="Product photography for Goa-based brand"
        role="presentation"
      />
    </div>
    <div class="service-content">
      <h2 class="service-title">Photography Services</h2>
      <p class="service-description">
        Our Goa-based photography team captures your brand with precision and
        style. Whether it's product shoots, corporate portraits, event coverage,
        or campaign visuals, we focus on lighting, composition, and storytelling
        to deliver images that resonate.
      </p>
    </div>
  </div>
  <div class="service-divider"></div>
  <div class="service-row reverse content-wrapper">
    <div class="service-image">
      <img
        src="/assets/services/video-production/videography.webp"
        loading="lazy"
        width="445"
        height="431"
        alt="Corporate video shoot in Goa"
        role="presentation"
      />
    </div>
    <div class="service-content">
      <h2 class="service-title">Videography & Editing</h2>
      <p class="service-description">
        Geekeno's videography and editing services in Goa include corporate
        films, brand videos, YouTube content, and social media reels. We handle
        everything from on-location shooting to color grading, sound design, and
        motion graphics — ensuring your video aligns with your brand and
        marketing goals.
      </p>
    </div>
  </div>
  <div class="service-divider"></div>
  <div class="service-row content-wrapper">
    <div class="service-image">
      <img
        src="/assets/services/video-production/remote-video-editing.avif"
        loading="lazy"
        width="445"
        height="431"
        alt="Remote video editing interface"
        role="presentation"
      />
    </div>
    <div class="service-content">
      <h2 class="service-title">Remote Video & Photo Editing</h2>
      <p class="service-description">
        Already have footage or images shot elsewhere? Our editors bring them to
        life with professional cuts, color grading, motion graphics, and sound
        design — delivering polished content that reflects your brand vision, no
        matter where it was filmed.
      </p>
    </div>
  </div>
</section>
